import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';
  
class CancellationRefunds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET  });
        });
    }

    handleClickModalLogOut = () => {
        $('#ModalLogout').modal('show');
    }

    handleClickLogOut = () => {
        localStorage.removeItem('userData');
        this.setState({ LoggedOut:true });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }
    
    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
    }
    
    render() { 

        //console.log(localStorage.getItem('delCity'));
        //console.log(localStorage.getItem('delArea'));

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Cancellation & Refunds';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';
        
        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section full mt-2">
                        <div className="pr-2 pl-2 pt-2 pb-1 font-size-14">
                            <ul className="set1 p-0" style={{'listStyle' : 'none'}}>
                                <li>
                                    <h5>Cancellation</h5>
                                    <ul className="set2 pl-2 pb-2">
                                        <li className="mb-1">As a general rule you shall not be entitled to cancel your order once you have received
                                            confirmation of the same. If you cancel your order after it has been confirmed, Done
                                            Delivery / Palasha Enterprises shall have a right to charge you cancellation fee of a
                                            minimum INR 100/- upto the order value, with a right to either not to refund the order
                                            value or recover from your subsequent order, the complete/ deficit cancellation fee, as
                                            applicable, to compensate our shop and delivery partners. Done Delivery/ Palasha
                                            Enterprises shall also have right to charge you cancellation fee for the orders cancelled by
                                            Done Delivery/ Palasha Enterprises for the reasons specified under clause 1(iii) of this
                                            cancellation and refunds policy. In case of cancellations for the reasons attributable to
                                            Done Delivery/ Palasha Enterprises or its shop and delivery partners, Done Delivery/
                                            Palasha Enterprises shall not charge you any cancellation fee.</li>
                                        <li className="mb-1">However, in the unlikely event of an item on your order being unavailable, we will contact
                                            you on the phone number provided to us at the time of placing the order and inform you of
                                            such unavailability. In such an event you will be entitled to cancel the entire order and
                                            shall be entitled to a refund in accordance with our refund policy.</li>
                                        <li className="mb-1">We reserve the sole right to cancel your order in the following circumstance:
                                            <ul className="set3 pt-05">
                                                <li className="mb-05">in the event of the designated address falls outside the delivery zone offered by us;</li>
                                                <li className="mb-05">failure to contact you by phone or email at the time of confirming the order
                                                    
                                                    booking;</li>
                                                <li className="mb-05">failure to deliver your order due to lack of information, direction or authorization
                                                    
                                                    from you at the time of delivery; or</li>
                                                <li className="mb-05">unavailability of all the items ordered by you at the time of booking the order; or</li>
                                                <li className="mb-05">unavailability of all the items ordered by you at the time of booking the order; or</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <h5>Refunds</h5>
                                    <ul className="set2 pl-2 pb-2">
                                        <li className="mb-1">You shall be entitled to a refund only if you pre-pay for your order at the time of placing
                                            
                                            your order on the Platform and only in the event of any of the following circumstances:
                                            <ul className="set3 pt-05">
                                                <li className="mb-05">your order packaging has been tampered or damaged at the time of delivery;</li>
                                                <li className="mb-05">us cancelling your order due to
                                                    <ul className="set4 pt-05">
                                                        <li className="mb-05">your delivery location following outside our designated delivery zones;</li>
                                                        <li className="mb-05">failure to contact you by phone or email at the time of confirming the order booking; or</li>
                                                        <li className="mb-05">failure to contact you by phone or email at the time of confirming the order booking; or</li>
                                                    </ul>
                                                </li>
                                                <li className="mb-05">you cancelling the order at the time of confirmation due to unavailability of the items you ordered for at the time of booking.</li>
                                                <li className="mb-05">Our decision on refunds shall be at our sole discretion and shall be final and binding.</li>
                                                <li className="mb-05">All refund amounts shall be credited to your account within 3-4 Working Banking days in
                                                    
                                                    accordance with the terms that may be stipulated by the bank which has issued the credit /
                                                    
                                                    debit card.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li> In case of payment at the time of delivery, you will not be required to pay for:
                                    <ul className="set2 pt-05">
                                        <li className="mb-05">orders where the packaging has been tampered or damaged by us;</li>
                                        <li className="mb-05">wrong order being delivered; or</li>
                                        <li className="mb-05">items missing from your order at the time of delivery.</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default CancellationRefunds;


// WEBPACK FOOTER //
// ./src/components/CancellationRefunds.js